import auth from "./js/auth";
import Vue from "vue";
import VueRouter from "vue-router";

//Home
import DefaultHome from "./views/Home/DefaultHome.vue";

//Navigations
//import Home from "./views/Home/Home.vue";
import FinancialAnalysis from "./views/FinancialAnalysis/FinancialAnalysis.vue";
import ITSSearch from "./views/ITS/Search.vue";
import ITSUpload from "./views/ITS/Upload.vue";
import SystemMaintenance from "./views/AccessControl/SystemDisturbance.vue";
import Unauthenticated from "./views/AccessControl/Unauthenticated.vue";
import Unauthorized from "./views/AccessControl/Unauthorized.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "hash",
    routes: [
        {
            path: "*",
            beforeEnter: redirect
        },
        {
            path: '/',
            alias: '/',
            component: DefaultHome,
            children: [
                /* Main Home page is to be activated later with enabling Navigation
                {
                    path: '',
                    alias: '',
                    component: Home,
                    beforeEnter: validateStaff
                },
                {
                    path: '/home',
                    alias: '',
                    component: Home,
                    beforeEnter: validateStaff
                },                
                */
                {
                    path: '', //'/financialanlaysis'
                    alias: '',
                    name: "financialanalysis",
                    component: FinancialAnalysis,
                    beforeEnter: validateStaff
                },
                {
                    path: '/financialanlaysis',
                    alias: '/financialanlaysis',
                    name: "financialanalysis",
                    component: FinancialAnalysis,
                    beforeEnter: validateStaff
                },
                {
                    path: '/searchdata',
                    alias: '/searchdata',
                    name: "searchdata",
                    component: ITSSearch,
                    beforeEnter: validateITS
                },
                {
                    path: '/uploadcsv',
                    alias: '/uploadcsv',
                    name: "uploadcsv",
                    component: ITSUpload,
                    beforeEnter: validateITS
                }
            ],
            beforeEnter: requireAuth, validateStaff
        },
        {
            path: "/unauthenticated",
            name: "unauthenticated",
            alias: "/unauthenticated",
            component: Unauthenticated,
            beforeEnter: checkAuthentication
        },
        {
            path: "/unauthorized",
            name: "unauthorized",
            alias: "/unauthorized",
            component: Unauthorized,
            beforeEnter: checkAuthorization
        },
        {
            path: "/undermaintenance",
            name: "undermaintenance",
            alias: "/undermaintenance",
            component: SystemMaintenance
        }
    ]
});

function checkAuthentication(to, from, next) {
    // Check user authentication
    auth.authenticate().then(function (response) {
            if (response) {
                // Redirect to proper route
                redirectTo(next);
            } else {
                // Redirect to unauthenticated view
                next();
            }
        })
        .catch(function () {
            // Redirect to unauthenticated view
            next();
        })
}

function checkAuthorization(to, from, next) {
    // Check user authorization
    if(auth.is_Student()){
        next();
    }else {
        next({
            path: '/'
        });
    }
}

function redirect(to, from, next) {
    // Redirect all paths to unauthenticated check
    next({
        path: '/unauthenticated'
    });
}

function requireAuth(to, from, next) {
    // Check user authentication
    auth.authenticate().then(function (response) {
        if (response) {
            next();
        } else {
            // Redirect to unauthenticated view
            next({
                path: '/unauthenticated'
            });
        }
    }).catch(function () {
        // Redirect to unauthenticated view
        next({
            path: '/unauthenticated'
        });
    })
}

function redirectTo(next) {
    // Redirect based on session type - department
    if (!auth.is_Student()) {
        next({
            path: '/'
        });
    }else {
        next({
            path: '/unauthorized'
        });
    }
}

function validateStaff(to, from, next) {
    // Check if the user is a Staff
    if (auth.is_Student()) {
        next({
            path: '/unauthorized'
        });
    } else {
        next();
    }
}

function validateITS(to, from, next){
    //Check if the user is from ITS
    if(auth.is_ITS()){
        next();
    }else {
        next({
            path: '/unauthorized'
        });
    }
}

export default router;